import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "./store";
import { fetchAuthToken, logout } from "./auth-action";
import { Loading } from "./ui-slice";

interface AuthState {
    token: string;
    userName: string;
    role: string;
    isAuth: boolean;
    loading: Loading
    errorMessage: undefined | string;
}

const initialState: AuthState = {
    token: "",
    userName: "",
    role: "",
    isAuth: false,
    loading: "hidden",
    errorMessage: undefined
}

const authSlice = createSlice({
    name: "auth",
    initialState,

    reducers: {
        authStateSucceeded: (state) => {
            state.loading = "hidden"
        }
    },

    extraReducers: (builder) => {
        builder.addCase(fetchAuthToken.pending, (state) => {
            state.loading = "pending";
        });

        builder.addCase(fetchAuthToken.fulfilled, (state, action) => {
            const { token, userName, role } = action.payload;
            state.isAuth = true;
            state.token = token;
            state.userName = userName;
            state.role = role;
            state.loading = "succeeded";
        });

        builder.addCase(fetchAuthToken.rejected, (state, action) => {
            state.errorMessage = action.payload?.message;
            state.isAuth = false;
            state.loading = "failed";
        });

        builder.addCase(logout.pending, (state) => {
            state.loading = "pending";
        });

        builder.addCase(logout.fulfilled, (state) => {
            state.isAuth = false;
            state.loading = "succeeded";
            state.token = "";
        });
    }
})


// export const { removeToken } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const currentToken = (state: RootState) => state.auth.token
export const authActions = authSlice.actions;
export default authSlice